var map = {
	"./desktop": [
		57383,
		9,
		46066,
		82587,
		99670,
		33458,
		67142,
		21603,
		23255,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		59035,
		93757,
		72680,
		60693,
		69193
	],
	"./desktop/": [
		57383,
		9,
		46066,
		82587,
		99670,
		33458,
		67142,
		21603,
		23255,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		59035,
		93757,
		72680,
		60693,
		69193
	],
	"./desktop/LatestNews": [
		71319,
		9,
		46066,
		67142,
		23255,
		59035,
		93757,
		72680,
		56930
	],
	"./desktop/LatestNews.js": [
		71319,
		9,
		46066,
		67142,
		23255,
		59035,
		93757,
		72680,
		56930
	],
	"./desktop/LatestNews.scss": [
		23125,
		7,
		97531
	],
	"./desktop/index": [
		57383,
		9,
		46066,
		82587,
		99670,
		33458,
		67142,
		21603,
		23255,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		59035,
		93757,
		72680,
		60693,
		69193
	],
	"./desktop/index.js": [
		57383,
		9,
		46066,
		82587,
		99670,
		33458,
		67142,
		21603,
		23255,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		59035,
		93757,
		72680,
		60693,
		69193
	],
	"./mobile": [
		7326,
		9,
		46066,
		67142,
		21603,
		23255,
		49510,
		67675,
		25018,
		37063,
		59035,
		66179,
		40699
	],
	"./mobile/": [
		7326,
		9,
		46066,
		67142,
		21603,
		23255,
		49510,
		67675,
		25018,
		37063,
		59035,
		66179,
		40699
	],
	"./mobile/LatestNews": [
		19973,
		9,
		46066,
		67142,
		23255,
		59035,
		82562
	],
	"./mobile/LatestNews.js": [
		19973,
		9,
		46066,
		67142,
		23255,
		59035,
		82562
	],
	"./mobile/LatestNews.scss": [
		15006,
		7,
		12545
	],
	"./mobile/index": [
		7326,
		9,
		46066,
		67142,
		21603,
		23255,
		49510,
		67675,
		25018,
		37063,
		59035,
		66179,
		40699
	],
	"./mobile/index.js": [
		7326,
		9,
		46066,
		67142,
		21603,
		23255,
		49510,
		67675,
		25018,
		37063,
		59035,
		66179,
		40699
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40676;
module.exports = webpackAsyncContext;